import { FC } from 'react';
import { Stack } from '@mantine/core';
import Subtitle from 'components/Subtitle';
import FieldText from './FieldText';

const GuardianInfo: FC = () => {
    return (
        <>
            <Subtitle title="Huoltajan tiedot" />
            <p>Jos olet alle 13-vuotias, tarvitsemme huoltajan yhteystiedot. Pyydäthän luvan tulla mukaan.</p>
            <Stack gap="sm">
                <FieldText name="huoltajaNimi" title="Huoltajan nimi" />
                <FieldText name="huoltajaPuhelin" title="Huoltajan puhelinnumero" />
            </Stack>
        </>
    );
};

export default GuardianInfo;
